import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import { User, Power } from 'react-feather';

import {
  Tooltip,
  Menu,
  MenuItem,
  IconButton as MuiIconButton,
  ListItemIcon,
  ListItemText
} from '@material-ui/core';
import { spacing } from '@material-ui/system';

import { AuthContext } from '../../../../core/AuthContext';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

const StyledListItemText = styled(ListItemText)(spacing);

function UserDropdown() {
  const [anchorMenu, setAnchorMenu] = React.useState<any>(null);
  const authenticationContext = useContext(AuthContext);

  const toggleMenu = (event: React.SyntheticEvent) => {
    setAnchorMenu(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorMenu(null);
  };

  const [logoutMutation] = GQLOperationBuilder.security.logout({
    variables: {},
    onCompleted: logoutResponse => {
      authenticationContext.unsetAuthentication();
    }
  });

  const handleSignOut = () => {
    closeMenu();
    logoutMutation({ variables: {} }).then();
  };

  return (
    <React.Fragment>
      <Tooltip title="Account">
        <IconButton
          aria-owns={Boolean(anchorMenu) ? 'menu-appbar' : undefined}
          aria-haspopup="true"
          onClick={toggleMenu}
          color="inherit"
        >
          <User />
        </IconButton>
      </Tooltip>
      <Menu id="menu-appbar" anchorEl={anchorMenu} open={Boolean(anchorMenu)} onClose={closeMenu}>
        <MenuItem onClick={handleSignOut}>
          <ListItemIcon>
            <Power />
          </ListItemIcon>
          <StyledListItemText inset primary="Sign out" pl={0} />
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}

export default UserDropdown;
